
<div mat-dialog-title class="red">Delete Selected External Accounts<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>
  <div>
    <table>
      <tr>
        <td style="vertical-align: top;">
          <span class="material-icons red" style="font-size: 36px;">delete_forever</span>
        </td>
        <td>
          <div style="margin-bottom: 10px;"><strong>{{externalAccounts.length}} of {{selectedCount}} selected accounts will be deleted.</strong></div>
          <div>Note: Accounts held at TD Ameritrade Institutional will not be deleted.</div>
        </td>
      </tr>
    </table>
  </div>
  @if (!isUiTest) {
    <irb-inventory-grid
      [style.width] = "'100%'"
      [style.height] = "'120px'"
      [style.minHeight]="'60px'"
      [style.maxHeight]="'210px'"
      [showSideBar] = "false"
      [gridOptions] = "gridOptions"
      [frameworkComponents] = 'frameworkComponents'
      [rowData] = 'externalAccounts'
    (gridReady) = "onGridReady($event)"></irb-inventory-grid>
  }
  <div style="padding-top: 10px;">Note: If you manually entered orders for any of these external accounts, those orders will be removed from the order blotter when you delete the account.</div>
  <!--    <div>-->
  <!--        <table width="100%">-->
  <!--            <tr>-->
  <!--                <td style="vertical-align: top; width: 125px; padding: 10px 0;"><strong>Accounts</strong></td>-->
  <!--                <td style="padding: 10px; background-color: #fad1cf;">-->
  <!--                    <div id="selectedAccounts" style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">-->
  <!--                        <table id="deleteAccounts" style="width:100%;" *ngIf="externalAccounts && externalAccounts.length > 0">-->
  <!--                            <tr *ngFor="let externalAccount of externalAccounts">-->
  <!--                                <td style="max-width: 410px; white-space:nowrap; text-overflow: ellipsis;">{{externalAccount.accountNumber}}</td>-->
  <!--                                <td style="max-width: 410px; white-space:nowrap; text-overflow: ellipsis;">{{externalAccount.accountName}}</td>-->
<!--                            </tr>-->
<!--                        </table>-->
<!--                    </div>-->
<!--                </td>-->
<!--            </tr>-->
<!--        </table>-->

<!--    </div>-->

@if (affectedPortfolios) {
  <div style="margin-bottom: 10px;padding-top: 10px;"><strong>{{affectedPortfolios.length}} portfolios (below) will be affected by deleting these accounts</strong></div>
}
@if (!isUiTest) {
  <irb-inventory-grid
    [style.width] = "'100%'"
    [style.minHeight]="'60px'"
    [style.height] = "'120px'"
    [style.maxHeight]="'210px'"
    [showSideBar] = "false"
    [gridOptions] = "affectedPortfoliosGridOptions"
    [frameworkComponents] = 'affectedPortfoliosGridOptions.frameworkComponents'
    [rowData] = 'affectedPortfolios'
  (gridReady) = "onAffectedPortfoliosGridReady($event)"></irb-inventory-grid>
}
<!--    <div>-->
<!--       -->
<!--        <table width="100%">-->
<!--            <tr>-->
<!--                <td style="vertical-align: top; width: 125px; padding: 10px 0;"><strong>Affected Portfolios</strong></td>-->
<!--                <td style="padding: 10px; background-color: #fad1cf;">-->
<!--                    <div id="selectedPortfolios" style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">-->
<!--                        <table id="deletePortfolios" style="width:100%;" *ngIf="affectedPortfolios && affectedPortfolios.length > 0">-->
<!--                            <tr *ngFor="let portfolio of affectedPortfolios">-->
<!--                                <td style="max-width: 410px; white-space:nowrap; text-overflow: ellipsis;">{{portfolio}}</td>-->
<!--                            </tr>-->
<!--                        </table>-->
<!--                    </div>-->
<!--                </td>-->
<!--            </tr>-->
<!--        </table>-->
<!--    </div>-->
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-tertiary">Cancel</button>
  <button mat-button class="btn-medium-primary red" (click)="deleteSelectedExternalAccounts()"><span class="material-icons" style="font-size: 16px; margin-top: -3px;">delete_forever</span>&nbsp;Delete</button>
</mat-dialog-actions>
